import { Component, ImageViewer } from "../..";
import { ImageViewerValues } from "./ImageViewerValues";
import { OpenButtons, OpenButtonsProps } from "../openButtons/OpenButtons";
import { OpenType } from "../openButtons/OpenType";
import { StringUtil, UrlUtil } from "@mcleod/core";

/**
 * This class provides the 'open in new tab/window' buttons to be used in conjunction with the ImageViewer.
 */
export class ImageViewerOpenButtons extends OpenButtons {
    private imageViewerValues: ImageViewerValues;
    private readonly imageViewerValuesProvider: () => ImageViewerValues|Promise<ImageViewerValues>;

    constructor(parentComponent: Component,
        imageViewerValuesProvider: () => ImageViewerValues|Promise<ImageViewerValues>,
        overrideProps?: Partial<OpenButtonsProps>) {
        super({
            allowedTypes: [OpenType.SAME_TAB, OpenType.NEW_TAB_WITH_SWITCH, OpenType.NEW_WINDOW],
            defaultType: OpenType.NEW_WINDOW,
            itemDescr: "image",
            layoutPath: "components/page/imageViewer/ImageViewer",
            localSettingsKey: "imageViewer.openButtons",
            urlFinalizer: (url: string) => {
                const querystring = UrlUtil.buildQueryString({
                    imageId: this.imageViewerValues.id,
                    fileName: StringUtil.stringBeforeLast(this.imageViewerValues.fileName, ".")
                });
                return Promise.resolve(url + querystring);
            },
            parentComponent,
            ...overrideProps
        });
        this.imageViewerValuesProvider = imageViewerValuesProvider;
    }

    protected override async openInSameTab(_url: string): Promise<void> {
        // Open the image modally in the ImageViewer
        ImageViewer.viewImage(this.imageViewerValues);
    }

    public async open(type: OpenType = this.defaultTypeForUser): Promise<void> {
        this.defaultButton.busy = true;
        this.imageViewerValues = await this.imageViewerValuesProvider();

        // If the image cannot be previewed, call viewOrDownload so that it is downloaded.  The user will be notified by
        // that method via a snackbar.
        if (ImageViewer.eligibleToView(this.imageViewerValues.fileName) !== true) {
            ImageViewer.viewOrDownload(this.imageViewerValues);
            return;
        }
        super.open(type);
    }
}
